import { useCallback, useEffect, useState } from "react";

import { Card } from "../../../components/Card";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { Flex, Skeleton, Stack } from "@chakra-ui/react";
import { Input } from "../../../components/Form/Input";

import { api } from "../../../services/api";
import { useParams } from "react-router";
import { AxiosError } from "axios";
import { BackButton } from "../../../components/atoms/Button/BackButton";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../hooks/toast";
import { SubmitButton } from "../../../components/atoms/Button/SubmitButton";

const createUserFormSchema = yup.object().shape({
  name: yup
    .string()
    .required("Nome obrigatório")
    .min(3, "O nome deve conter no mínimo 3 caracteres"),
  radical: yup.string().optional(),
});

export function EditFranchise() {
  const navigate = useNavigate();
  const toast = useToast();
  let { id } = useParams();

  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState, reset, setValue } = useForm({
    resolver: yupResolver(createUserFormSchema),
  });

  useEffect(() => {
    api
      .get(`/franchises/${id}`)
      .then((response) => {
        reset(response.data);
      })
      .catch((err: AxiosError) => {
        navigate(`/error/${err.response?.status}`);
      });
    setLoading(true);
  }, [id, reset, setValue, navigate]);

  const handleEditFranchise: SubmitHandler<FieldValues> = useCallback(
    async (formValue) => {
      try {
        await api.put(`/franchises/${id}`, {
          name: formValue.name,
          radical: formValue.radical,
        });
        navigate("/redes");
        toast({
          title: "Rede editada com sucesso!",
          status: "success",
        });
      } catch (err) {
        toast({
          title: "Não foi possível editar a rede",
          status: "error",
        });
      }
    },
    [id, navigate, toast]
  );

  const { errors } = formState;

  return (
    <>
      <Skeleton isLoaded={loading}>
        <Card
          border="#216ca5"
          title="Editar Rede"
          header={<BackButton onClick={() => navigate(-1)} />}
          body={
            <Flex
              as="form"
              flexDir="column"
              w="100%"
              onSubmit={handleSubmit(handleEditFranchise)}
              id="add-form"
            >
              <Stack spacing="4">
                <Input
                  type="text"
                  label="Nome"
                  isRequired={true}
                  error={errors.name}
                  {...register("name")}
                />
                <Input
                  type="text"
                  label="Radical"
                  isRequired={false}
                  error={errors.radical}
                  {...register("radical")}
                />
              </Stack>
            </Flex>
          }
          footer={<SubmitButton formState={formState} text="Editar" />}
        />
      </Skeleton>
    </>
  );
}
